module.exports = __webpack_public_path__ + "img/apres1.e5112a0c.png";